export default "__VITE_ASSET__Bnx$1zLA__"